import React, { useState, useEffect } from "react";
import Header from "../../layout/Header";
import Sidebar from "../../layout/Sidebar";
import { message, Spin } from "antd";
import Button from "../../components/Button";
import Bridge from "../../constants/Bridge";
import Strings from "../../constants/Strings";
import $ from 'jquery';

const Add = () => {
  const [name, setName] = useState("");
  const [link, setLink] = useState("");
  const [title, setTitle] = useState("");
  const [publicationDetails, setPublicationDetails] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    Bridge.audit_logs.view_add_consortia_upload();
    if ($(window).width() < 600) {
      console.log("window::", window);
      $("#sidebar").removeClass("show-sidebar").addClass("hide-sidebar");
    } else {
      $("#sidebar").removeClass("hide-sidebar").addClass("show-sidebar");
    }
  }, []);

  const addConsortiaUpload = () => {
    if (name === "") {
      message.warning("Please enter name.");
      return;
    } else if (link === "") {
      message.warning("Please enter link");
      return;
    } else if (title === "") {
      message.warning("Please enter title.");
      return;
    } else if (!publicationDetails) {
      message.warning("Please enter publication details");
      return;
    }
    let params = {
      name,
      link,
      title,
      publication_details: publicationDetails,
      consortia_user_id: localStorage.getItem("consortia_user_id"),
    };
    setLoading(true);
    Bridge.consortia_upload
      .add(params)
      .then((result) => {
        if (result.status === 1) {
          message.success(result.message, 5);
          setName("");
          setLink("");
          setTitle("");
          setPublicationDetails("");
          window.location.assign("/consortia-uploads");
        } else {
          message.error(result.message, 5);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  return (
    <div>
      <Header />
      <div className="row">
        <Sidebar />
        <div className="col-lg-10 ml-auto main-section add-user top-space">
          <a href="/consortia-uploads" className="go-back">
            <i className="fas fa-chevron-left"></i>
          </a>
          <div className="wrapper clearfix" style={{ paddingTop: 0 }}>
            <div className="multisteps-form add-admin-user-form">
              <div className="row">
                <div className="col-12 col-lg-12 m-auto">
                  <Spin spinning={loading}>
                    <div
                      className="multisteps-form__panel js-active addStudentForm"
                      data-animation="slideVert"
                    >
                      <div className="inner pb-100">
                        <div className="wizard-content-form">
                          <div
                            className="wizard-form-field"
                            style={{ margin: "53px 0 0" }}
                          >
                            <h3 className="user-profile-heading">
                              {Strings.consortaiUploadAdd}
                            </h3>
                            <br />
                            <div className="row">
                              <div className="col-lg-7">
                                <label className="label-name">Name</label>
                                <div className="wizard-form-input position-relative form-group has-float-label">
                                  <input
                                    type="text"
                                    name="name"
                                    className="form-control"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                  />
                                </div>
                                <label className="label-name">Link</label>
                                <div className="wizard-form-input position-relative form-group has-float-label">
                                  <input
                                    type="text"
                                    name="link"
                                    className="form-control"
                                    value={link}
                                    onChange={(e) => setLink(e.target.value)}
                                  />
                                </div>
                                <label className="label-name">Title</label>
                                <div className="wizard-form-input position-relative form-group has-float-label">
                                  <input
                                    type="text"
                                    name="title"
                                    className="form-control"
                                    value={title}
                                    onChange={(e) => setTitle(e.target.value)}
                                  />
                                </div>
                                <label className="label-name">
                                  Publication Details
                                </label>
                                <textarea
                                  id="txtid"
                                  name="publication_details"
                                  value={publicationDetails}
                                  onChange={(e) =>
                                    setPublicationDetails(e.target.value)
                                  }
                                  rows={2}
                                  cols={50}
                                  style={{
                                    width: "100%",
                                    padding: 20,
                                    background: "#ddeef9",
                                    fontSize: 18,
                                    border: "none",
                                  }}
                                ></textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                        <Button
                          to="#"
                          isClickable={true}
                          click={addConsortiaUpload}
                          style={{ marginLeft: 4, marginTop: 20 }}
                        >
                          <i className="fa fa-arrow-right"></i>&nbsp; Submit
                        </Button>
                      </div>
                    </div>
                  </Spin>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Add;
